
import { Article, AppButton, AppSection } from "@soenergy/frontend-library"

export default {
  components: {
    AppButton,
    AppSection,
    Article
  },
  props: {
    heading: {
      type: String,
      default: ""
    },
    isHeadingUppercase: {
      type: Boolean,
      default: false
    },
    copy: {
      type: Object,
      default: null
    },
    fontColor: {
      type: String,
      default: ""
    },
    backgroundColor: {
      type: String,
      default: ""
    },
    backgroundImage: {
      type: Object,
      default: null
    },
    button: {
      type: Array,
      default: null
    },
    isLarge: {
      type: Boolean,
      default: false
    },
    alignLeftOnMobile: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    buttonProps() {
      const buttonBlock = this.button && this.button[0]
      if (buttonBlock) {
        const { _uid, component, ...props } = buttonBlock
        return props
      }
      return null
    }
  }
}
